import PageTitle from 'components/ui/pageTitle/pageTitle'
import React from 'react'
import ServicesForm from './components/servicesForm/servicesForm'

export default function Services() {
  return (
    <>
      <PageTitle>Services</PageTitle>
      <ServicesForm />
    </>
  )
}
